export { locationsEn } from './en';
export { locationsSk } from './sk';
export { locationsCz } from './cz';

// Helper function to get locations by language
import { locationsSk } from './sk';
import { locationsEn } from './en';
import { locationsCz } from './cz';

export function getLocations(lang: 'sk' | 'en' | 'cz') {
  switch (lang) {
    case 'sk':
      return locationsSk;
    case 'en':
      return locationsEn;
    case 'cz':
      return locationsCz;
    default:
      return locationsEn; // fallback to English
  }
}
